import { render } from "./globalOTPVerification.vue?vue&type=template&id=5e4698a8&scoped=true"
import script from "./globalOTPVerification.vue?vue&type=script&lang=js"
export * from "./globalOTPVerification.vue?vue&type=script&lang=js"

import "./globalOTPVerification.vue?vue&type=style&index=0&id=5e4698a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4698a8"]])

export default __exports__